import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../pages/css/PhoneNumberList.css';
import banner from '../images/Hrias-b2b-banner.png';
import verifiedPhone from '../images/Hrias-ai-1.png';
import phoneConnect from '../images/Hrias-ai-2.png';
import b2bcrm from '../images/Hrias-ai-3.png';
import phoneMultiple from '../images/Hrias-ai-4.png';
import cTOne from '../images/kpmg.png';
import cTTwo from '../images/deloite.png';
import cTThree from '../images/berkshire.png';
import cTFive from '../images/pwc.jpg';
import cTSix from '../images/microsoft.png';
import cTFour from '../images/Google.png';
import dashImg from '../images/Hrias-ai-dash.png';

function AiPersonalization() {
    return (
        <div className="phone-list-page">

            {/* ===== Hero Section ===== */}
            <section
                className="hero-section text-center text-white d-flex align-items-center justify-content-center"
                style={{
                    backgroundImage:
                        `url(${banner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    width: "100%",
                    height: "40vh",
                }}
            >
                <div className="container" style={{ color: "#ffffff" }}>
                    <h1 className="fw-bold" style={{ color: "#275a8eff" }}>
                        Engage with prospects   <span className="highlight" style={{ color: "#7102c1ff" }}>in a human way, at machine speed.</span> with HRIAS
                    </h1>
                    <p className="lead mt-3" style={{ color: "#890059ff" }}>
                        Need help finding, connecting, and converting your ideal B2B leads? HRIAS AI works like your smartest sales rep — only faster, smarter, and built for scale.
                    </p>
                    <button
                        className="btn btn-primary mt-4"
                        style={{
                            backgroundColor: "#134373ff",
                            border: "none",
                            color: "#ffffffff",
                            fontWeight: "600",
                            borderRadius: "30px",
                            padding: "12px 30px",
                            transition: "all 0.3s ease",
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = "#5197dcff")}
                        onMouseOut={(e) => (e.target.style.backgroundColor = "#134373ff")}
                    >
                        Contact Sales
                    </button>
                </div>

            </section>

            <section>
                <div className="container py-5">
                    <img
                        src={dashImg}
                        alt="Padded Container"
                        className="img-fluid rounded shadow-lg"
                    />
                </div>
            </section>

            <section className="container my-5 partner-section">
                {/* Heading */}
                <h5 className="text-center partner-heading">
                    Trusted by <span style={{ color: '#fd7e14' }}>6000+</span> Industry Leaders
                </h5>

                {/* Logo Row */}
                <div className="d-flex justify-content-center align-items-center flex-wrap gap-4 mt-4">
                    <img src={cTOne} alt="KPMG" className="partner-logo" style={{ width: '120px', height: 'auto' }} />
                    <img src={cTTwo} alt="Deloitte" className="partner-logo" style={{ width: '130px', height: 'auto' }} />
                    <img src={cTThree} alt="Berkshire" className="partner-logo" />
                    <img src={cTFour} alt="Google" className="partner-logo" />
                    <img src={cTFive} alt="PwC" className="partner-logo" />
                    <img src={cTSix} alt="Microsoft" className="partner-logo" />
                </div>
            </section>


            <section className="accuracy-section py-5 bg-light">
                <div className="container text-center">
                    <h2 className="section-heading">Let AI handle it — Reach the right people, at the right time, with the right message.</h2>
                    <p className="text-muted mb-4">
                        With HRIAS AI segmentation, effortlessly identify and target high-value prospects. Our system analyzes company data, seniority levels, hiring trends, and growth signals to help you build precise audience segments that convert faster and smarter.
                    </p>
                    <img
                        src={verifiedPhone}
                        alt="Verification Process"
                        className="img-fluid rounded shadow"
                    />
                </div>
            </section>

            {/* ===== Section 2: Overview ===== */}
            <section className="overview-section py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <h2 className="fw-bold mb-3">Use clean data for human-like outreach</h2>
                            <p>
                                Avoid robotic messaging with HRIAS Smart Data Cleaner. Automatically fix name capitalization, standardize job titles, format dates, and remove emojis — ensuring every message feels authentic and personalized.
                            </p>
                        </div>
                        <div className="col-md-6 text-center">
                            <img src={phoneConnect} alt="Phone list" className="img-fluid rounded shadow" />
                        </div>
                    </div>
                </div>
            </section>



            {/* ===== Section 5: Two Image Boxes ===== */}
            <section className="two-box-section py-5 bg-light">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="image-box p-3 rounded shadow-sm h-100">
                                <h4 className="fw-bold mb-2">Craft optimized multichannel sequences in one click</h4>
                                <p>Share your outreach goals, and let HRIAS AI instantly build personalized sequences across Email, LinkedIn, and WhatsApp — reaching the right prospects, at the right time, with the perfect message.</p>
                                <img src={b2bcrm} alt="Instant Access" className="img-fluid rounded mt-3" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="image-box p-3 rounded shadow-sm h-100">
                                <h4 className="fw-bold mb-2">Fine-tune every message for maximum impact</h4>
                                <p>You’re a sales expert, not a copywriter. HRIAS AI refines your outreach for the perfect tone, length, and relevance — ensuring every message feels personal, engaging, and built to convert.</p>
                                <img src={phoneMultiple} alt="Custom Data" className="img-fluid rounded mt-3" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="accuracy-section py-5 bg-light">
                <div className="container text-center">
                    <h2 className="section-heading">Make outreach truly personal with smart insights</h2>
                    <p className="text-muted mb-4">
                        Your prospects expect you to understand their business. HRIAS AI gathers key details like company background, competitor data, and pain points from LinkedIn profiles, websites, and public sources — helping you craft hyper-personalized messages at scale without hours of manual research.
                    </p>
                    <img
                        src="https://cdn.prod.website-files.com/5de921a1902d8d8b7a99f774/67b33efdcea5cea21fcd1395_make-outreach-personal-with-relevant-details.png"
                        alt="Verification Process"
                        className="img-fluid rounded shadow"
                    />
                </div>
            </section>

            {/* ===== Section 6: Credibility / Stats ===== */}
            <section className="stats-section py-5 text-center">
                <div className="container">
                    <h2 className="fw-bold mb-4">Trusted by Sales Teams Globally</h2>
                    <div className="row justify-content-center">
                        <div className="col-md-3 mb-3">
                            <h3 className="text-primary fw-bold">98%</h3>
                            <p>Accuracy Rate</p>
                        </div>
                        <div className="col-md-3 mb-3">
                            <h3 className="text-primary fw-bold">500K+</h3>
                            <p>Verified Numbers</p>
                        </div>
                        <div className="col-md-3 mb-3">
                            <h3 className="text-primary fw-bold">150+</h3>
                            <p>Countries Covered</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== Section 7: Call to Action ===== */}
            <section className="cta-section text-center py-5">
                <div className="container">
                    <h2 className="fw-bold mb-3 text-white">Start Accessing Verified leads Today</h2>
                    <p className="mb-4">Boost your sales calls and connect faster with decision-makers using 100% verified data.</p>
                    <button className="btn btn-primary px-4 py-2">Contact Sales</button>
                </div>
            </section>

            <section className="container my-5 client-review-section">
                <div className="row align-items-center">
                    {/* Left side - client image */}
                    <div className="col-12 col-md-3 text-center">
                        <img
                            src="https://img.freepik.com/premium-photo/studio-portrait-handsome-young-man-astonished-with-something_1048944-17590200.jpg?semt=ais_hybrid&w=740&q=80" // replace with your client's photo
                            alt="Client"
                            className="client-img"
                        />
                    </div>

                    {/* Right side - review text */}
                    <div className="col-12 col-md-9">
                       <p className="client-review">
  “HRIAS AI Personalization has completely redefined how we connect with prospects.  
  Every message now sounds natural, hyper-personalized, and genuinely human.  
  The AI understands tone, intent, and timing — making our outreach more authentic and doubling our response rates.  
  It’s like having a smart assistant that knows exactly what to say, every time.”
</p>
<h3 className="client-name">Ethan Carter</h3>
<p className="client-position">Director of Sales, LuminaConnect</p>


                    </div>
                </div>
            </section>

        </div>
    );
}

export default AiPersonalization;
